/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

import ControllersGroup from '../../../controllers/ControllersGroup';
import {
  InputLineController,
  ToggleSwitchController,
  RangeController,
  ChoiceBoxController,
  SelectController,
  CustomSortController,
} from '../../../controllers/Base';

const defaultProps = {
  config: undefined,
  handle: () => {},
  data: undefined,
  extend: '',
  setExtend: () => {},
  selectedLine: undefined,
};

const GeneralControllers = ({
  config = defaultProps.config,
  data = defaultProps.undefined,
  handle = defaultProps.handle,
  extend = defaultProps.extend,
  setExtend = defaultProps.setExtend,
  selectedLine = defaultProps.selectedLine,
}) => (
  <>
    <ControllersGroup
      title="Opções Gerais"
      id="general"
      key="general"
      extend={extend}
      setExtend={setExtend}
      sizeIncrease={config?.SortValuesControl === 'Customizado' ? data?.index?.length : 0}
    >
      {Boolean(selectedLine) && (
        <>
          <SelectController
            label="Ordenar campos"
            handle={handle}
            kWord="SortValuesControl"
            options={[
              { label: 'Automático', value: 'Não ordenado', id: 'nao-ordenado' },
              { label: 'Alfabética A-Z', value: 'Alfabética A-Z', id: 'alfabetica-a-z' },
              { label: 'Alfabética Z-A', value: 'Alfabética Z-A', id: 'alfabetica-z-a' },
              { label: 'Valor Crescente', value: 'Valor Crescente', id: 'valor-crescente' },
              { label: 'Valor Decrescente', value: 'Valor Decrescente', id: 'valor-decrescente' },
              { label: 'Customizado', value: 'Customizado', id: 'customizado' },
            ]}
            configValue={config?.SortValuesControl}
            fullWidth
          />
          {config?.SortValuesControl === 'Customizado' && (
            <CustomSortController
              handle={handle}
              kWord="CustomSortControlUpt"
              oldOrder={data?.index || []}
              newOrder={config?.CustomSortControl?.kpiCategories || []}
              removeTotal
            />
          )}
        </>
      )}
      <ToggleSwitchController
        label="Inverter barras"
        handle={handle}
        kWord="ReverseControl"
        configValue={config?.ReverseControl?.checked}
        firstOption=""
        secondOption=""
        fullWidth
      />
      <ChoiceBoxController
        label="Formato"
        handle={handle}
        kWord="LayoutControl"
        configValue={config?.LayoutControl}
        options={[
          { label: 'horizontal', value: 'horizontal', id: 'horizontal' },
          { label: 'vertical', value: 'vertical', id: 'vertical' },
        ]}
        fullWidth
      />
      {Boolean(selectedLine) && (
        <ChoiceBoxController
          label="Tipo de gráfico"
          handle={handle}
          kWord="GroupModeControl"
          configValue={config?.GroupModeControl}
          options={[
            { value: 'stacked', label: 'Empilhado', id: 'stacked' },
            { value: 'separated', label: 'Separado', id: 'separated' },
          ]}
          fullWidth
        />
      )}
      <ChoiceBoxController
        label="Formato da métrica"
        handle={handle}
        kWord="MetricTypeControl"
        configValue={config?.MetricTypeControl}
        options={[
          { value: 'bar', label: 'Barra', id: 'metric-bar' },
          { value: 'line', label: 'Linha', id: 'metric-line' },
        ]}
        fullWidth
      />
      {config?.MetricTypeControl === 'bar' ? (
        <RangeController
          label="Tamanho da barra de métrica"
          handle={handle}
          kWord="MeasureSizeControl"
          configValue={config?.MeasureSizeControl}
          min={0.1}
          max={1}
          step={0.1}
          precision={1}
          fullWidth
        />
      ) : (
        <RangeController
          label="Tamanho da linha de métrica"
          handle={handle}
          kWord="MarkersSizeControl"
          configValue={config?.MarkersSizeControl}
          min={0.1}
          max={2}
          step={0.1}
          precision={1}
          fullWidth
        />
      )}
      {Boolean(selectedLine) && config?.GroupModeControl === 'separated' && (
        <RangeController
          label="Espaço entre as barras"
          handle={handle}
          kWord="BarsPaddingControl"
          configValue={config?.BarsPaddingControl}
          min={0}
          max={100}
          step={1}
          precision={0}
          fullWidth
        />
      )}
      <RangeController
        label="Margem Superior"
        handle={handle}
        kWord="MarginTop"
        configValue={config?.Margin?.top}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Inferior"
        handle={handle}
        kWord="MarginBottom"
        configValue={config?.Margin?.bottom}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Esquerda"
        handle={handle}
        kWord="MarginLeft"
        configValue={config?.Margin?.left}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Direita"
        handle={handle}
        kWord="MarginRight"
        configValue={config?.Margin?.right}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <ToggleSwitchController
        label="Valor mínimo"
        handle={handle}
        kWord="MinValueControl2"
        configValue={config?.MinValueControl?.checked}
        firstOption="Automático"
        secondOption="Manual"
        secondColor="secondary"
      />
      <InputLineController
        isNumber
        precision={2}
        label=""
        handle={handle}
        kWord="MinValue"
        configValue={config?.MinValueControl?.value}
        disabled={config?.MinValueControl?.checked}
      />
      <ToggleSwitchController
        label="Valor máximo"
        handle={handle}
        kWord="MaxValueControl2"
        configValue={config?.MaxValueControl?.checked}
        firstOption="Automático"
        secondOption="Manual"
        secondColor="secondary"
      />
      <InputLineController
        isNumber
        precision={2}
        label=""
        handle={handle}
        kWord="MaxValue"
        configValue={config?.MaxValueControl?.value}
        disabled={config?.MaxValueControl?.checked}
      />
      <ChoiceBoxController
        label="Dados primários"
        handle={handle}
        kWord="DataFormat"
        configValue={config?.DataFormat}
        options={[
          { value: 'absolute', label: 'Absoluto', id: 'absolute' },
          { value: 'percentual', label: 'Percentual', id: 'percentual' },
        ]}
        fullWidth
      />
      {config?.DataFormat === 'absolute' && (
        <ChoiceBoxController
          label="Formato absoluto"
          handle={handle}
          kWord="DataAbsoluteFormat"
          configValue={config?.DataAbsoluteFormat}
          options={[
            { label: 'Número', value: 'number', id: 'number' },
            { label: 'Duração', value: 'duration', id: 'duration' },
          ]}
          fullWidth
        />
      )}
      {(
        config?.DataFormat === 'absolute' && config?.DataAbsoluteFormat === 'duration'
      ) && (
        <>
          <hr style={{ width: '100%', color: 'lightgray', opacity: '0.2' }} />
          <ChoiceBoxController
            label="Unidade original"
            handle={handle}
            kWord="DurationUnit"
            configValue={config?.DurationUnit}
            options={[
              { label: 'Dias', value: 'days', id: 'days' },
              { label: 'Horas', value: 'hours', id: 'hours' },
              { label: 'Minutos', value: 'minutes', id: 'minutes' },
              { label: 'Segundos', value: 'seconds', id: 'seconds' },
            ]}
            fullWidth
          />
        </>
      )}
    </ControllersGroup>
  </>
);

GeneralControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  selectedLine: PropTypes.shape({}),
};

export default GeneralControllers;
